// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentChecklistTable-moduleApplicantDocumentChecklistTable__gUsLc";
var _2 = "ApplicantDocumentChecklistTable-modulerows__ngIaZ";
export { _1 as "ApplicantDocumentChecklistTable", _2 as "rows" }
